import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";
import { ValueDisplay } from "../../ValueDisplay";
import { FieldDisplayRendererProps } from "./types";

export const StatusDisplayRenderer = ({
  field,
  value,
  t,
  valueStyle,
}: FieldDisplayRendererProps) => {
  return (
    <View style={[styles.row, { alignItems: "flex-start" }]}>
      <Text style={styles.label}>{t(field.label)}:</Text>
      <ValueDisplay
        value={value}
        field={field}
        style={valueStyle}
        collectionPickerContainerStyles={{
          alignItems: "flex-end",
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  label: {
    color: "#555555",
  },
});
